import React from 'react';
import nodeJs from '../../assets/nodejs.png';

const Node = () => (
  <section id="node">
    <img style={{width: 500, height: "auto"}} data-src={nodeJs} alt="NodeJS" />
    <p>
      1<small>er</small> version en 2009<br />
      Environnement <strong>JavaScript</strong> côté serveur<br />
      Utilisé en tant que plateforme logicielle<br />
    </p>
  </section>
);

export default Node;
